<template>
  <svg width="90" height="90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <filter x="-70%" y="-50%" width="240%" height="240%" filterUnits="objectBoundingBox" id="ngi9r0rn4a">
              <feMorphology radius="5" in="SourceAlpha" result="shadowSpreadOuter1"/>
              <feOffset dy="10" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
              <feGaussianBlur stdDeviation="15" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
              <feColorMatrix values="0 0 0 0 0.239215686 0 0 0 0 0.239215686 0 0 0 0 0.239215686 0 0 0 0.222929414 0" in="shadowBlurOuter1"/>
          </filter>
          <rect id="8s6e399gwb" x="0" y="0" width="50" height="50" rx="25"/>
      </defs>
      <g fill="none" fill-rule="evenodd">
          <g transform="translate(20 10)">
              <use fill="#000" filter="url(#ngi9r0rn4a)" xlink:href="#8s6e399gwb"/>
              <use fill="#FFF" xlink:href="#8s6e399gwb"/>
          </g>
          <path d="M51.374 23.005 48.29 23c-3.465 0-5.704 2.297-5.704 5.853v2.699h-3.101a.485.485 0 0 0-.485.485v3.91c0 .268.217.485.485.485h3.1v9.866c0 .268.218.485.486.485h4.046a.485.485 0 0 0 .485-.485v-9.866h3.625a.485.485 0 0 0 .485-.485l.002-3.91a.486.486 0 0 0-.485-.485h-3.627v-2.288c0-1.1.262-1.658 1.694-1.658h2.078a.485.485 0 0 0 .484-.485V23.49a.485.485 0 0 0-.484-.485z"/>
      </g>
  </svg>
</template>

<script>
export default {

}
</script>

<style>
svg path {
    fill: var(--color-primary);
}
</style>